module.exports = __webpack_public_path__ + "img/builder-36.feec56d4.jpg";